import { Button, message, Modal } from "antd";
import React, { useContext, useEffect, useRef } from "react";
import MultiStepFormContext from "./MultiStepFormContext";
import ReactToPrint from "react-to-print";
import dayjs from "dayjs";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import { useState } from "react";
import useDatasource from "./datasource";
import { isBoolean } from "lodash";
import PdfViewer from "./pdfViewer";

const Review = () => {
  const [checked, setChecked] = useState(false);
  const [visible, setVisible] = useState(false);
  const showModal = () => {
    setVisible(true);
  };
  const navigate = useNavigate();

  const handleOk = async () => {
    try {
      const url = window.API_PREFIX + "forms/api/post/submit_form";
      const requestOptions = {
        status: "submitted",
        applicationId: appId,
        token: sessionStorage.getItem("token"),
      };
      const result = await axios.post(url, requestOptions);
      if (result.status === 200) {
        message.info("Form submitted successfully!");
        setVisible(false);
        navigate("/Success");
      } else {
        throw new Error(result.message);
      }
    } catch (error) {
      message.error("Failed to submit the form! Please try again later.");
    }
  };

  const handleCancel = () => {
    setVisible(false);
  };

  const {
    details,
    familyDetails,
    educationRecords,
    assistanceRequirement,
    references,
    documents,
  } = useContext(MultiStepFormContext);

  const { dataSource } = useDatasource();

  const appId = sessionStorage.getItem("applicationId");

  const [comments, setComments] = useState();

  const transformedPersonalDetails = Object.entries(details).map(
    ([key, value]) => {
      if (key === "dateOfBirth") {
        return {
          field: key,
          ...value,
          value: dayjs(value.value).format("DD-MM-YYYY"),
        };
      } else if (isBoolean(value.value)) {
        return {
          field: key,
          ...value,
          value: value.value === true ? "Yes" : "No",
        };
      } else {
        return {
          field: key,
          ...value,
        };
      }
    }
  );

  // dateOfBirth

  const transformedEduAssis = Object.entries(assistanceRequirement).map(
    ([key, value]) => {
      if (key === "courseEndDate" || key === "courseStartDate") {
        return {
          field: key,
          ...value,
          value: `${dayjs(value.value).format("MMM-YYYY")}`,
        };
      } else {
        return {
          field: key,
          ...value,
        };
      }
    }
  );

  const userRole = sessionStorage.getItem("role");
  useEffect(() => {
    const getReviews = async () => {
      const url = window.API_PREFIX + `forms/api/get/get_reviews/${appId}`;
      let headers = {
        Authorization: sessionStorage.getItem("token"),
      };
      const res = await axios.get(url, { headers });
      if (res.data.status === 200) {
        setComments(res.data.message[0]?.comments);
      } else {
        console.error(res.status);
        message.info("Couldnt fetch the comments for the application.!");
      }
    };
    if (userRole !== "Student") {
      getReviews();
    }
  }, [appId, userRole]);

  const printRef = useRef(null);

  const reactToPrintContent = React.useCallback(() => {
    return printRef.current;
  }, []);

  const reactToPrintTrigger = React.useCallback(() => {
    return <Button type={"primary"}>Print</Button>;
  }, []);

  const handleSubmitReview = async (status) => {
    try {
      const url = window.API_PREFIX + "forms/api/post/submit_form";
      const requestOptions = {
        status: status === "accepted" ? "accepted" : "rejected",
        applicationId: appId,
        token: sessionStorage.getItem("token"),
        comments: comments,
      };
      const result = await axios.post(url, requestOptions);
      if (result.data.status === 200) {
        message.success("Application status updated");
      } else {
        throw new Error(`${result.message}`);
      }
    } catch (error) {
      message.error("Something went wrong.! Please try again later.", error);
    }
  };

  return (
    <>
      <div ref={printRef}>
        <div
          style={{
            width: "100%",
            padding: "1.25rem 3.125rem",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          <div class="row">
            <h4>Personal Details</h4>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Field</b>
                    </TableCell>
                    <TableCell>
                      <b>Values</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transformedPersonalDetails.map((item) => (
                    <TableRow
                      key={item.field}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {item.label}
                      </TableCell>
                      <TableCell component="th" scope="row">
                        {String(item.value ? item.value : "-")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div class="row">
            <h4>Family Details</h4>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Name</b>
                    </TableCell>
                    <TableCell>
                      <b>Relationship</b>
                    </TableCell>
                    <TableCell>
                      <b>Date of Birth</b>
                    </TableCell>
                    <TableCell>
                      <b>Education</b>
                    </TableCell>
                    <TableCell>
                      <b>Occupation</b>
                    </TableCell>
                    <TableCell>
                      <b>Annual Income</b>
                    </TableCell>
                    <TableCell>
                      <b>Dependent</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {familyDetails["familyDetails"].map((item, i) => (
                    <TableRow
                      key={i}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {item.name ? item.name : "-"}
                      </TableCell>
                      <TableCell>
                        {item.relationship ? item.relationship : "-"}
                      </TableCell>
                      <TableCell>
                        {item.dateOfBirth
                          ? dayjs(item.dateOfBirth).format("DD-MM-YYYY")
                          : "-"}
                      </TableCell>
                      <TableCell>
                        {String(item.education ? item.education : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.occupation ? item.occupation : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.annualIncome ? item.annualIncome : "-")}
                      </TableCell>
                      <TableCell>{item.dependent ? "Yes" : "No"}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div class="row">
            <h4>Education Details</h4>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Level</b>
                    </TableCell>
                    <TableCell>
                      <b>Institution</b>
                    </TableCell>
                    <TableCell>
                      <b>Location</b>
                    </TableCell>
                    <TableCell>
                      <b>Duration</b>
                    </TableCell>
                    <TableCell>
                      <b>Stream/Subjects</b>
                    </TableCell>
                    <TableCell>
                      <b>Percentage</b>
                    </TableCell>
                    <TableCell>
                      <b>Enrollment Number</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {educationRecords["educationRecords"].map((item, i) => (
                    <>
                      <TableRow
                        key={i}
                        sx={{
                          "&:last-child td, &:last-child th": { border: 0 },
                        }}
                      >
                        <TableCell component="th" scope="row">
                          {String(item.level ? item.level : "-")}
                        </TableCell>
                        <TableCell>
                          {String(item.institution ? item.institution : "-")}
                        </TableCell>
                        <TableCell>
                          {String(item.location ? item.location : "-")}
                        </TableCell>
                        <TableCell>
                          {String(item.duration ? item.duration : "-")}
                        </TableCell>
                        <TableCell>
                          {String(
                            item.streamSubjects ? item.streamSubjects : "-"
                          )}
                        </TableCell>
                        <TableCell>
                          {String(
                            item.percentageGrade ? item.percentageGrade : "-"
                          )}
                        </TableCell>
                        <TableCell>
                          {String(item.rollNumber ? item.rollNumber : "-")}
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div class="row">
            <h4>
              Education Assistance for{" "}
              <u>{educationRecords["educationAssistanceRequiredFor"]}</u>
            </h4>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Field</b>
                    </TableCell>
                    <TableCell>
                      <b>Values</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {transformedEduAssis.map((item) => (
                    <TableRow
                      key={item.filed}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {String(item.label)}
                      </TableCell>
                      <TableCell>
                        {String(item.value ? item.value : "-")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div class="row">
            <h4>Refrences</h4>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Name</b>
                    </TableCell>
                    <TableCell>
                      <b>Address</b>
                    </TableCell>
                    <TableCell>
                      <b>Occupation</b>
                    </TableCell>
                    <TableCell>
                      <b>Mobile Phone</b>
                    </TableCell>
                    <TableCell>
                      <b>Office Phone</b>
                    </TableCell>
                    <TableCell>
                      <b>Email</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {references["references"].map((item, i) => (
                    <TableRow
                      key={i}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell component="th" scope="row">
                        {String(item.name ? item.name : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.address ? item.address : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.occupation ? item.occupation : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.mobilePhone ? item.mobilePhone : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.officePhone ? item.officePhone : "-")}
                      </TableCell>
                      <TableCell>
                        {String(item.email ? item.email : "-")}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
          <div class="row">
            <h4>Documents</h4>
            <TableContainer component={Paper}>
              <Table aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <TableCell>
                      <b>Files</b>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {Object.keys(documents).map((item, i) => (
                    <TableRow
                      key={i}
                      sx={{ "&:last-child td, &:last-child th": { border: 0 } }}
                    >
                      <TableCell
                        component="th"
                        scope="row"
                        style={{
                          display: "flex",
                          flexDirection: "column",
                          gap: "1rem",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            alignItems: "center",
                            gap: ".625rem",
                          }}
                        >
                          {
                            dataSource.find((ds) => ds.document_id === item)
                              ?.document_title
                          }
                        </div>
                        <PdfViewer pdfUrl={documents[item]} />
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>
        </div>
      </div>
      <CustomModal
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
        checked={checked}
        setChecked={setChecked}
      />

      <>
        <div
          style={{
            width: "100%",
            padding: "1.25rem 2.125rem",
            display: "flex",
            flexDirection: "column",
            gap: "20px",
          }}
        >
          {userRole === "Student" ? (
            <Button type={"primary"} onClick={showModal}>
              Submit
            </Button>
          ) : (
            <>
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: ".625rem",
                }}
              >
                <div>
                  <TextArea
                    value={comments}
                    onChange={(e) => setComments(e.target.value)}
                    placeholder="Comment on the application"
                    autoSize={{ minRows: 3, maxRows: 10 }}
                  />
                </div>
                <div style={{ width: "100%", display: "flex", gap: ".625rem" }}>
                  <Button
                    type="primary"
                    danger
                    onClick={() => handleSubmitReview("rejected")}
                  >
                    Reject
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => handleSubmitReview("accepted")}
                  >
                    Approve
                  </Button>
                  <Button
                    type="primary"
                    onClick={() => handleSubmitReview("under_process")}
                  >
                    Under Process
                  </Button>
                </div>
              </div>
              <ReactToPrint
                content={reactToPrintContent}
                documentTitle={`${appId}_${details.firstName.value} ${details.lastName.value}`}
                removeAfterPrint
                trigger={reactToPrintTrigger}
              />
            </>
          )}
        </div>
      </>
    </>
  );
};
export default Review;

const CustomModal = ({ visible, onOk, onCancel, checked, setChecked }) => (
  <Modal
    open={visible}
    onOk={onOk}
    onCancel={onCancel}
    okButtonProps={{ disabled: !checked }}
    okText="Submit"
    title={
      <>
        Once the form is submitted, you won't be able to edit it later. Are you
        sure you want to submit the form?
        <br />
        <br />
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "flex-start",
            gap: "5px",
          }}
        >
          <input
            type="checkbox"
            name="confirm"
            style={{
              width: "20px",
              height: "20px",
            }}
            checked={checked}
            onChange={(e) => {
              setChecked(e.target.checked);
            }}
          />
          <span>
            I hereby declare that all the information provided above is true to
            the best of my knowledge, and all the submitted documents are
            genuine. I understand that if, at any point, any information or
            documents are found to be false, my application in the AdiMahesh
            Seva Foundation for education assistance may be subject to
            cancellation.
          </span>
        </div>
      </>
    }
  />
);
